// components/ConfirmModal.js
import WarningIcon from '@mui/icons-material/Warning'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import ErrorIcon from '@mui/icons-material/Error'
import InfoIcon from '@mui/icons-material/Info'
import './ConfirmModal.css'

function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Bestätigen',
  cancelText = 'Abbrechen',
  type = 'warning' // 'warning', 'danger', 'success', 'info'
}) {
  if (!isOpen) return null

  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <ErrorIcon className='modal-icon danger' />
      case 'success':
        return <CheckCircleIcon className='modal-icon success' />
      case 'info':
        return <InfoIcon className='modal-icon info' />
      case 'warning':
      default:
        return <WarningIcon className='modal-icon warning' />
    }
  }

  return (
    <div className='confirm-modal-overlay' onClick={onClose}>
      <div
        className={`confirm-modal-content ${type}`}
        onClick={e => e.stopPropagation()}
      >
        <div className='confirm-modal-header'>
          {getIcon()}
          <h3>{title}</h3>
        </div>

        <div className='confirm-modal-body'>
          <p>{message}</p>
        </div>

        <div className='confirm-modal-actions'>
          <button className='btn-cancel' onClick={onClose}>
            {cancelText}
          </button>
          <button className={`btn-confirm ${type}`} onClick={handleConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
